<style scoped lang="scss">
  @import "../user";
  @import "./ipone";
</style>
<template>
  <div class="user">
    <section>
      <h3 class="title">Sanger测序订单</h3>
      <div class="search-form">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="关联用户：" v-if="isHeadMan">
              <el-select v-model="searchForm.customerId" filterable clearable>
                  <el-option
                          v-for="item in courseInfo.members"
                          :key="item.id"
                          :label="item.realName"
                          :value="item.id">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="订单号：">
            <el-input v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="客户备注：">
            <el-input v-model="searchForm.customerRemark" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="下单时间：" class="date">
            <el-date-picker
              v-model="searchForm.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结果下载状态：">
            <el-select v-model="searchForm.resultDownloadStatus" filterable clearable>
              <el-option
                  v-for="item in resultDownloadStatus"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="完成时间：" class="date">
            <el-date-picker
              v-model="searchForm.endTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="bindSearch" class="search-button">搜索</el-button>
          </el-form-item>
        </el-form>
        <div class="d-flex flex-align-center">
            <div class="flex-1">
                订单状态：
                <el-radio-group v-model="status" @change="getOrders">
                    <el-radio label="">全部</el-radio>
                    <el-radio label="ING">进行中</el-radio>
                    <el-radio label="OK">已完成</el-radio>
                </el-radio-group>
            </div>
            <el-dropdown class="mr10" @command="handleGadgetCommand">
              <el-button type="primary" class="sanger_button">
                云工具 <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item v-for="(item,index) in dropdownList" :key="index" :command="item.value">{{ item.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="primary" @click="$throttle(bindDownLoad())" class="sanger_button">结果下载</el-button>
            <el-button type="primary" @click="$throttle(getDetailsExcel())" class="sanger_button">明细表下载</el-button>
            <el-button type="primary" @click="$router.push('/user/sanger_search')" class="sanger_button">测序订单综合查询</el-button>
        </div>
      </div>
      <el-table
        class="mt20"
        border
        :data="tableData"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="50">
        </el-table-column>
        <el-table-column
          label="订单编号"
          width="245px">
          <template slot-scope="scope">
            <router-link :to="`/user/sanger_details?id=${scope.row.value.id}`">{{scope.row.value.no}}</router-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerRemark"
          width="90px"
          label="客户备注">
          <template slot-scope="scope">{{scope.row.value.customerRemark ||''}}</template>
        </el-table-column>
        <el-table-column
          prop="date"
          label="下单时间"
          width="160px">
          <template slot-scope="scope">{{scope.row.value.createTime | rTime}}</template>
        </el-table-column>
        <el-table-column
          prop="totalNum"
          width="90px"
          label="反应总数">
        </el-table-column>
        <el-table-column
          prop="okNum"
          width="90px"
          label="成功数">
        </el-table-column>
        <el-table-column
          v-if="isHeadMan"
          prop="customerName"
          label="关联用户">
        </el-table-column>
        <el-table-column
          width="120px"
          label="订单金额（元）">
          <template slot-scope="scope">{{scope.row.value.settlementAmount | amount}}</template>
        </el-table-column>
        <el-table-column
          prop="value.orderStatusName"
          label="订单状态">
        </el-table-column>
        <el-table-column
          prop="value.endTime"
          label="完成时间"
          width="160px">
          <template slot-scope="scope">{{scope.row.value.endTime | rTime}}</template>
        </el-table-column>
        <el-table-column
          prop="value.resultDownloadStatus"
          label="结果下载状态">
          <template slot-scope="scope">{{baseMethods.enToChinese(scope.row.value.resultDownloadStatus, resultDownloadStatus)}}</template>
        </el-table-column>
      </el-table>
      <div class="page tr">
        <el-pagination
          :page-size="10"
          :pager-count="9"
          layout="prev, pager, next"
          :total="total"
          @current-change="changePage">
        </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import { sequencingOrders,sangerWorderDocK, peakDown,sangerSettlement,sangerExcel } from '@/services/api.index'
import { canAnalysisAb1ByCode } from '@/services/api.tools'
import { showLoading, hideLoading } from './loading'
const resultDownloadStatus = [
  { label: "全部", value: "" },
  { label: "未下载", value: "NO" },
  { label: "部分下载", value: "PART" },
  { label: "全部下载", value: "ALL" },
]
export default {
  data() {
    return {
      resultDownloadStatus,
      searchForm: {
        orderNo: '',
        customerId: '',
        customerRemark:'',
        date: null,
        resultDownloadStatus: ""
      },
      dropdownList: [
        {
          label: "序列拼接",
          value: "seqStitching"
        },
        {
          label: "峰图（ab1转pdf）",
          value: "seqPeakPlots"
        },
        {
          label: "导出ab1分析报告",
          value: "seqExportReport"
        },
        {
          label: "SNP分析",
          value: "seqSNPAnalysis"
        },
      ],
      status: '',
      multipleSelection:[],
      tableData: [],
      orderTable:[],
      loading:false,
      selectedIds:[],
      selectedId1:[],
      selectedId2:[],
      reactionLists:[],
      reactionTotal: 0,
      total: 0,
      page: 0,
      reactionPage: 0,
      reactionSize: 10,
      pageSize: 10,
      isHeadMan: this.baseMethods.isHeadMan(),
      courseInfo: this.baseMethods.getLocalObj('courseInfo'),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6 // 如果没有后面的-8.64e6就是不可以选择今天的
        }
      }
    }
  },
  created() {
    this.getOrders();
  },
  methods: {
    getOrders () {
      const { page, pageSize, status } = this
      let { orderNo, date, customerId,customerRemark, endTime, resultDownloadStatus} = this.searchForm
      date = date || ['', '']
      endTime = endTime || ['', '']
      const searchIds = this.baseMethods.getSearchId(customerId)
      sequencingOrders(page, pageSize, orderNo, ...date, ...endTime, status, ...searchIds,customerRemark, resultDownloadStatus).then(res => {
        res.data.list.map(item => {
          item.value.orderStatusName = this.baseMethods.orderStatus(item.userWebOrderStatus)
        })
        this.tableData = res.data.list
        console.log('*****8')
        console.log(this.tableData)
        this.total = res.data.totalCount
      })
    },
    getDetailsExcel() {
      if (!this.selectedIds || this.selectedIds.length !== 1) {
        this.$message.warning("请选择一个订单进行下载");
        return;
      }
      showLoading();
      setTimeout(() => {
        sangerExcel(this.selectedIds).then((res) => {
          hideLoading()
          this.baseMethods.downloadFile(res.data, this.multipleSelection[0].value.no +"明细表");
        }).catch(() => hideLoading());
      }, 2000);
    },
    bindSearch () {
      this.page = 0;
      this.getOrders();
    },
    getSettlement(value) {
      
      sangerSettlement(this.id).then((res) => {
        this.orderTable = this.orderTable.concat(
          Object.assign(value, res.data)
        );
      });
    },
    // 反应信息多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.selectedIds = val.map((v) => v.value.id);
      this.selectedId1 = val.map((v) => v.okNum);
      this.selectedId2 = val.map((v) => v.totalNum);
      console.log('1111',this.selectedId1)
      console.log('11',this.multipleSelection)
    },
    // 下载
    bindDownLoad() {
      const { multipleSelection } = this;
       if (multipleSelection.length === 0) {
         return this.$message.warning("请选择订单");
       }
      showLoading();
      setTimeout(() => {
        if (multipleSelection) { 
          let ids = [];
          multipleSelection.map((item) => {
            ids.push(item.value.id);
          });
          console.log('selectedId1',this.selectedId1)
          console.log('selectedId2',this.selectedId1)
          if(this.selectedId1 == 0 && this.selectedId2 != 0){
            sangerWorderDocK(ids).then((res) => {
              this.getOrders();
              hideLoading();
              console.log(res)
              this.baseMethods.downloadFile(
                res.data,
                `结果文件${this.baseMethods.dateToString()}`,
                "zip"
              );
            })
            .catch(() => hideLoading());
          } else if(this.selectedId1 == 0 && this.selectedId2 == 0){
            hideLoading();
            this.$message.error('没有可下载的文件');
          } else{
            sangerWorderDocK(ids).then((res) => {
              this.getOrders();
              hideLoading();
              console.log(res)
              this.baseMethods.downloadFile(
                res.data,
                `结果文件${this.baseMethods.dateToString()}`,
                "zip"
              );
            })
            .catch(() => hideLoading());
          }

        }
      },2000);
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getOrders();
    },
    // 小工具点击事件
    async handleGadgetCommand (command) {
      console.log("handleGadgetClick", this.multipleSelection)
      if(!this.multipleSelection.length) return this.$message.warning("请选择订单");
      const nos = this.multipleSelection.map((item) => item.value.no)
      // 判断是否有ab1文件
      let res = await canAnalysisAb1ByCode({orderCode:nos.join(";")})
      console.log(res)
      if(res.data){
        this.$router.push({
          name: command, 
          params: {
            nos
          }
        })
      }
      
    }
  }
}
</script>
<style scope>
@import "loading.css";
</style>



// WEBPACK FOOTER //
// src/views/user/children/sanger.vue